import { useEffect, useState } from 'react';
import { CustomEventName } from '@mb/lib';
import { Campaign, HeaderInspirationImages } from '../types';

export const useCollectionHeader = () => {
  const [showHeader, setShowHeader] = useState(false);
  const [campaign, setCampaign] = useState<Campaign | null>(null);

  const handleShowHeader = ({ detail }: CustomEvent<Campaign>) => {
    setShowHeader(true);
    const headerImages: HeaderInspirationImages = JSON.parse(
      // TODO: refactor without type assertion, or add comment
      // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
      detail.header_inspiration_images as unknown as string,
    );
    setCampaign({ ...detail, header_inspiration_images: headerImages });
  };

  useEffect(() => {
    document.addEventListener(
      CustomEventName.SHOW_COLLECTION_HEADER,
      handleShowHeader,
    );
    return () => {
      document.removeEventListener(
        CustomEventName.SHOW_COLLECTION_HEADER,
        handleShowHeader,
      );
    };
  }, []);

  useEffect(() => {
    const collectionHeaderEvent = new CustomEvent(
      CustomEventName.LOADED_COLLECTION_HEADER,
    );
    document.dispatchEvent(collectionHeaderEvent);
  }, []);

  return {
    showHeader,
    campaign,
  };
};
